<template>
	<div>
		<modalconfirm supplier ref="modalconfirmRetur" @action="proccessRetur"/>
		<modalDetail :dialog="dialog" @hideDialog="() => { dialog = false }"></modalDetail>
		<modalPrint :dialog="dialogPrint" @hideDialog="() => { dialogPrint = false }"></modalPrint>
		<div class="d-flex justify-space-between">
			<div class="text-h5">Data Retur</div>
		</div>
		<div v-if="loading">
			<loading-card-supplier></loading-card-supplier>
		</div>
		<div v-if="!loading">
			<v-card class="mt-3 mb-3" outlined>
				<v-list color="grey lighten-3" class="pa-3">
					<v-list-item dense class="px-1">
						<div>
							<v-tabs color="cyan darken-2" background-color="grey lighten-3" class="change-display" height="40">
								<v-tab @click="cardDisplay = true">
									<v-icon>mdi-card-bulleted</v-icon>
								</v-tab>
								<v-tab @click="cardDisplay = false">
									<v-icon>mdi-table</v-icon>
								</v-tab>
							</v-tabs>
						</div>
						<v-spacer></v-spacer>
						<v-btn text depressed class="cyan darken-2 white--text mr-2" @click="exportData">
							<v-icon>mdi-export</v-icon>
							<div class="pl-2 text-capitalize">Export</div>
						</v-btn>
						<v-btn text depressed class="cyan darken-2 white--text" @click="dropfilter = !dropfilter">
							<v-icon>mdi-filter</v-icon>
							<div class="pl-2 text-capitalize">Filter</div>
						</v-btn>
					</v-list-item>
				</v-list>
			</v-card>
			<v-slide-y-transition>
				<v-card outlined class="mb-3" v-if="dropfilter">
					<v-col cols="12" class="px-4">
						<v-row>
							<v-col cols="12" md="2" >
								<v-text-field outlined dense hide-details color="cyan darken-2" label="Kode Retur" v-model="por_code.value"></v-text-field>
							</v-col>
							<v-col cols="12" md="3" >
								<v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field outlined dense hide-details :value="convertDate(tanggalRetur)" label="Tanggal Retur" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hint="Bisa pilih range tanggal"></v-text-field>
									</template>
									<v-date-picker locale="id" first-day-of-week="0" range color="cyan darken-2" v-model="tanggalRetur" :max="today"></v-date-picker>
								</v-menu>
							</v-col>
							<v-col cols="12" md="4">
								<v-autocomplete item-text="" outlined dense hide-details color="cyan darken-2" v-model="por_status.value" :items="OptionStatusRetur" label="Status" no-data-text="Tidak ada data yang sesuai">
									<template v-slot:item = {item}>
										{{item | toStatusReturWH}}
									</template>
									<template v-slot:selection = {item}>
										{{item | toStatusReturWH}}
									</template>
								</v-autocomplete>
							</v-col>
							<v-col cols="12" md="3" class="text-right">
								<v-btn outlined color="grey darken-1" dark class="text-capitalize" @click="resetFilter()">Reset</v-btn>
								<v-btn depressed color="cyan darken-2" dark class="ml-2 text-capitalize" @click="cari()">Cari</v-btn>
							</v-col>
						</v-row>
					</v-col>
					<v-card-actions class="px-4" v-if="false">
						<v-spacer></v-spacer>
						<v-btn outlined color="grey darken-1" dark class="text-capitalize" @click="resetFilter()">Reset</v-btn>
						<v-btn depressed color="cyan darken-2" dark class="ml-2 text-capitalize" @click="cari()">Cari</v-btn>
					</v-card-actions>
				</v-card>
			</v-slide-y-transition>
			<v-card outlined v-show="!cardDisplay">
				<v-data-table dense loading :headers="headers" :items="listRetur" hide-default-footer :options.sync="option" :server-items-length="returPagination.total_data" disable-pagination>
					<template v-slot:item.created_datetime="{ item }">
						<div class="pt-2">{{ item.por_status_created_datetime | tanggalid }}</div>
						<div class="pt-3 pb-3">
							<v-btn x-small dense text color="grey darken-1" class="pl-0"><v-icon>mdi-printer</v-icon></v-btn>
							<v-btn x-small text color="cyan darken-2" dark class="pl-0"><v-icon>mdi-file-document-outline</v-icon></v-btn>
							<v-btn x-small dense text color="grey darken-1" class="pl-0"><v-icon>mdi-format-list-bulleted-square</v-icon></v-btn>
						</div>
					</template>
					<template v-slot:item.por_code="{ item }">
						<div>{{ item.por_code }}</div>
					</template>
					<template v-slot:item.supplier="{ item }">
						<div class="py-2">
							<div>{{ item.warehouse_name }}</div>
							<div class="pt-1"><v-icon small>mdi-phone</v-icon><span class="pl-2">{{ item.warehouse_mobilephone }}</span></div>
							<div class="pt-1"><v-icon small>mdi-map-marker</v-icon><span class="pl-2">{{ item.warehouse_address }}</span></div>
						</div>
					</template>
					<template v-slot:item.status="{ item }">
						<div class="pt-2 text-capitalize">{{ item.por_status | toStatusReturWH }}</div>
						<div class="pt-2 pb-2">
							<v-tooltip bottom>
								<template v-slot:activator="{ on, attrs }">
									<v-btn class="mr-1" fab dark x-small depressed color="green darken-1" v-bind="attrs" v-on="on" @click.stop="getDetail(item.por_code)">
										<v-icon dark>mdi-text-box-search</v-icon>
									</v-btn>
								</template>
								<span>Detail</span>
							</v-tooltip>
							<v-tooltip bottom v-if="item.por_status == 'wh_approved'">
								<template v-slot:activator="{ on, attrs }">
									<router-link :to="{ name: 'approve-retur-supplier', params: { code: item.por_code }}"  class="text-deco">
										<v-btn class="mr-1" fab dark x-small depressed color="cyan darken-2 white" v-bind="attrs" v-on="on">
											<v-icon dark>mdi-check</v-icon>
										</v-btn>
									</router-link>
								</template>
								<span>Approval Retur</span>
							</v-tooltip>
						</div>
					</template>
					<template v-slot:progress>
						<div>
						</div>
					</template>
					<template v-slot:loading>
						<div class="py-3" v-if="!returPagination">
							<loading-data-cyan></loading-data-cyan>
						</div>
						<div class="py-3" v-else>
							<not-found-cyan></not-found-cyan>
						</div>
					</template>
				</v-data-table>
			</v-card>
			<div v-show="cardDisplay">
				<v-card outlined v-if="listRetur.length == 0 && returPagination">
					<div class="py-3">
						<not-found-cyan></not-found-cyan>
					</div>
				</v-card>
				<v-card v-else class="mb-3" outlined v-for="retur in listRetur" :key="retur.por_id">
					<v-list color="grey lighten-3" class="pt-0 pb-0">
						<v-list-item dense>
							<v-list-item-content class="grey--text text--darken-2">
								Kode Retur {{ retur.por_code }}
							</v-list-item-content>
							<v-spacer></v-spacer>
							<v-btn small text depressed class="cyan darken-2 white--text"  @click="printRetur(retur.por_code)">
								<v-icon>mdi-printer</v-icon>
								<div class="pl-2 text-capitalize">Print</div>
							</v-btn>
						</v-list-item>
					</v-list>
					<v-list-item>
						<v-list-item-content>
							<v-layout wrap>
								<v-flex xs6 sm5 md5>
									<div class="body-2 oppacity-75">Warehouse</div>
									<div class="subtitle-2">{{ retur.warehouse_name }}</div>
									<div class="body-2 pt-3">
										<v-icon small>mdi-phone</v-icon><span class="pl-2">{{ retur.warehouse_mobilephone }}</span>
									</div>
									<div class="body-2 pt-1">
										<v-icon small>mdi-map-marker</v-icon><span class="pl-2">{{ retur.warehouse_address }}</span>
									</div>
								</v-flex>
								<v-flex xs6 sm3 md3>
									<div class="body-2 oppacity-75">Tanggal Retur</div>
									<div class="subtitle-2">{{ retur.por_status_created_datetime | tanggaljam }}</div>
								</v-flex>
								<v-flex xs6 sm3 md3>
									<div class="body-2 oppacity-75">Status</div>
									<div class="subtitle-2">{{ retur.por_status | toStatusReturWH }}</div>
								</v-flex>
								<v-flex xs6 sm1 md1 text-right>
									<div>
										<v-tooltip bottom>
											<template v-slot:activator="{ on, attrs }">
												<v-btn fab dark x-small depressed color="green darken-1" v-bind="attrs" v-on="on" class="mr-1" @click.stop="getDetail(retur.por_code)">
													<v-icon dark>mdi-text-box-search</v-icon>
												</v-btn>
											</template>
											<span>Detail</span>
										</v-tooltip>
										<v-tooltip bottom v-if="retur.por_status == 'wh_approved'">
											<template v-slot:activator="{ on, attrs }">
												<router-link :to="{ name: 'approve-retur-supplier', params: { code: retur.por_code }}"  class="text-deco">
													<v-btn class="mr-1" fab dark x-small depressed color="cyan darken-2 white" v-bind="attrs" v-on="on">
														<v-icon dark>mdi-check</v-icon>
													</v-btn>
												</router-link>
											</template>
											<span>Approval Retur</span>
										</v-tooltip>
									</div>
								</v-flex>
							</v-layout>
							<div class="pt-3">
								<v-card outlined>
									<v-data-table dense :headers="headersProduct" :items="retur.por_detail" :items-per-page="1000" class="elevation-0" hide-default-footer>
										<template v-slot:item.por_detail_quantity_approved="{ item }">
											<div>{{ item.por_detail_quantity_approved | toNumber }}</div>
										</template>
										<template v-slot:item.por_detail_quantity_delivered="{ item }">
											<div>{{ item.por_detail_quantity_delivered | toNumber }}</div>
										</template>
										<template v-slot:item.por_detail_quantity_transport="{ item }">
											<div>{{ item.por_detail_quantity_transport | toNumber }}</div>
										</template>
									</v-data-table>
									<!-- <div class="d-flex justify-end py-2">
										<div class="font-weight-bold text-right px-4">Total Pembayaran</div>
										<div class="font-weight-bold text-right px-4">{{ countGrandtotal(retur.por_detail, retur.por_status) | toRupiah }}</div>
									</div> -->
								</v-card>
							</div>
						</v-list-item-content>
					</v-list-item>
				</v-card>
			</div>
			<div class="pt-5">
				<v-row>
					<v-col cols="10" md="11" class="py-0 d-flex justify-end">
						<v-pagination v-if="returPagination.total_page > 1 && listRetur.length > 0" @input="changePage" v-model="page" :length="returPagination.total_page" total-visible="7" circle class="d-flex justify-end no-button-focus"></v-pagination>
					</v-col>
					<v-col cols="2" md="1" class="py-0 pl-0">
						<v-autocomplete :items="listLimit" @input="changeLimit" v-model="limit" hide-details class="mt-0" label="Item"></v-autocomplete>
					</v-col>
				</v-row>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions,  mapState, mapMutations } from 'vuex'
import modalDetail from '@/views/MLsupplier/retur/DetailRetur'
import modalPrint from '@/views/MLsupplier/retur/PrintRetur'

export default {
	inject: ['theme'],
	components: {
		modalDetail, modalPrint
	},
	data() {
		return {
			cardDisplay: true,
			menu: false,
			loading: true,
			tanggalRetur: [],
			por_code: {
				value:'',
				comparison: 'like',
				type: 'string',
				field: 'por_code'
			},
			por_date: {
				value:'',
				comparison: 'bet',
				type: 'date',
				field: 'por_status_created_datetime'
			},
			por_status: {
				value:'',
				comparison: '=',
				type: 'string',
				field: 'por_status'
			},
			sortBy: 'por_id',
			sortDir: 'DESC',
			page: 1,
			limit: '10',
			listLimit: [ '5', '10', '20', '50', '100' ],
			dropfilter: false,
			dialog: false,
			dialogPrint: false,
			dialogConfirm: false,
			headers: [
			{ text: 'Tanggal Retur', value: 'created_datetime' },
			{ text: 'Kode Retur', sortable: true, value: 'por_code'},
			{ text: 'Warehouse', value: 'supplier', sortable: false, width: "40%"},
			{ text: 'Status', value: 'status' },
			],
			headersProduct: [
			{ text: 'Nama Produk', value: 'supplier_product_name', sortable: false },
			{ text: 'Jumlah Retur', value: 'por_detail_quantity_approved', align: 'center', sortable: false },
			{ text: 'Jumlah Diterima', value: 'por_detail_quantity_delivered', align: 'center', sortable: false },
			{ text: 'Jumlah Dikirim', value: 'por_detail_quantity_transport', align: 'center', sortable: false },
			],
			params:[],
			procces_por_id: '',
			poProccess : '',
		}
	},
	computed: {
		...mapState('returSupplier', ['listRetur', 'returPagination', 'OptionStatusRetur']),
		...mapState('authSupplier', ['userData']),

	},
	methods: {
		...mapActions('returSupplier', ['getRetur', 'deleteRetur', 'getDetailRetur', 'exportRetur', 'getOptionStatusRetur']),
		...mapMutations('returSupplier', ['clearDataRetur']),
		...mapActions('commonSupplier', ['getLetterHeader']),

		getData() {
			this.getRetur().then(() => {
				this.getOptionStatusRetur().then(() => {
					this.loading = false
				})
			})
		},
		exportData() {
			this.exportRetur(this.queryString({params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		resetFilter() {
			this.por_code.value = ''
			this.por_date.value = ''
			this.tanggalRetur = []
			this.por_status.value = ''
			this.page = 1
			this.getRetur(this.queryString({limit:this.limit, page: this.page}))
		},
		cari() {
			this.params = []
			if (this.por_code.value)
				this.params.push(this.por_code)
			if (this.por_date.value) {
				if (this.por_date.value.length > 1) {
					this.por_date.value.sort()
					let date = this.por_date.value.join('::')
					this.por_date.value = date
				}
				this.params.push(this.por_date)
			}
			if (this.por_status.value)
				this.params.push(this.por_status)
			this.page = 1
			this.getRetur(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		changePage(page) {
			this.page = page
			this.getRetur(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getRetur(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		hapus(val) {
			this.procces_por_id = val
			this.poProccess = 'delete'
			let msg = "Yakin akan menghapus Retur ini?"
			this.$refs.modalconfirmRetur.showConfirm()
			this.$refs.modalconfirmRetur.setMessage(msg)
		},
		proccessRetur() {
			if (this.poProccess == 'delete') {
				this.deleteRetur(this.procces_por_id).then( () => {
					this.getRetur(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}))
				})
			}
			this.$refs.modalconfirmRetur.hideConfirm()
		},
		getDetail(code) {
			this.getDetailRetur(code).then(()=> {
				this.dialog = true
			})
		},
		async printRetur(code) {
			await this.getLetterHeader({
				supplier_id: this.userData.user_supplier_supplier_id
			})
			await this.getDetailRetur(code).then(()=> {
				this.dialogPrint = true
			})
		},
	},
	created() {
		this.$store.dispatch('setPageTitle', `Retur`)
		this.getData()
	},
	beforeDestroy() {
		this.clearDataRetur()
	},
	watch: {
		tanggalRetur(val) {
			this.por_date.value = val
		},
		option(val, old) {
			this.sortBy = val.sortBy[0]
			this.sortDir = val.sortDesc[0] ? 'ASC' : 'DESC'
			this.page = 1
			if (this.sortBy || (!this.sortBy && Object.keys(old).length > 0)) {
				this.getRetur(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}))
			}
		}
	}
};
</script>

<style>
tbody tr:nth-of-type(even) {
	background-color: rgba(0, 0, 0, .05);
}
.v-avatar .avatar {
	object-position: center;
	object-fit: cover;
}
</style>